import FooterModule from './Footer.module.scss'
import FaceIcon from '@mui/icons-material/Face'
import HomeIcon from '@mui/icons-material/Home'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import SettingsIcon from '@mui/icons-material/Settings'
import { useUserDataContext } from '../../context/AuthContext'
import { useEffect, useState } from 'react'
import { useGetTranslatedValue } from '../../lang/lang'

function Footer() {
  const translate = useGetTranslatedValue()
  const homePath = '/'
  const guidePath = 'https://plaid-scallop-d50.notion.site/AI-9584bf67ce314116ac72e45d4cf60fe4'
  const modeManagementPath = '/management'
  const userPath = '/mypage'
  const [role, setRole] = useState('')
  const [schoolId, setSchoolId] = useState('')
  const userData = useUserDataContext()

  useEffect(() => {
    if (!userData) {
      setRole('unknown')
      return
    }
    const { role = '', schoolDocId = '' } = userData
    setRole(role)
    setSchoolId(schoolDocId)
  }, [userData])

  const linearColors = 'linearColors'
  const iconClassName = 'linearColors'
  return (
    <div className={FooterModule.footer}>
      <ul className={FooterModule['bottom-menu']}>
        <li>
          <a className={FooterModule[iconClassName]} href={homePath}>
            <svg width={0} height={0}>
              <linearGradient id="linearColors" gradientTransform="rotate(90)">
                <stop offset={0} stopColor="#0080FE" />
                <stop offset={1} stopColor="#7eaef5" />
              </linearGradient>
            </svg>
            {window.location.pathname === homePath ? (
              <>
                <HomeIcon className={FooterModule[iconClassName]} sx={{ fill: 'url(#' + linearColors + ')' }} />
                <p style={{ color: '#7eaef5' }}>{translate('home')}</p>
              </>
            ) : (
              <>
                <HomeIcon className={FooterModule[iconClassName]} />
                <p>{translate('home')}</p>
              </>
            )}
          </a>
        </li>
        {role === 'student' && (
          <li>
            <a className={FooterModule[iconClassName]} href={guidePath} target="_blank" rel="noreferrer">
              {window.location.pathname === guidePath ? (
                <>
                  <MenuBookIcon className={FooterModule[iconClassName]} sx={{ fill: 'url(#' + linearColors + ')' }} />
                  <p style={{ color: '#7eaef5' }}>{translate('studentGuide')}</p>
                </>
              ) : (
                <>
                  <MenuBookIcon className={FooterModule[iconClassName]} />
                  <p>{translate('studentGuide')}</p>
                </>
              )}
            </a>
          </li>
        )}
        {(role === 'tutor' || role === 'admin') && (
          <li>
            <a
              className={FooterModule[iconClassName]}
              href={`${modeManagementPath}${schoolId ? '?school_id=' + schoolId : ''}`}
              target="_blank"
              rel="noreferrer"
            >
              {window.location.pathname === modeManagementPath ? (
                <>
                  <SettingsIcon className={FooterModule[iconClassName]} sx={{ fill: 'url(#' + linearColors + ')' }} />
                  <p style={{ color: '#7eaef5' }}>{translate('manageModes')}</p>
                </>
              ) : (
                <>
                  <SettingsIcon className={FooterModule[iconClassName]} />
                  <p>{translate('manageModes')}</p>
                </>
              )}
            </a>
          </li>
        )}
        <li>
          <a className={FooterModule[iconClassName]} href={userPath}>
            {window.location.pathname === userPath ? (
              <>
                <FaceIcon className={FooterModule[iconClassName]} sx={{ fill: 'url(#' + linearColors + ')' }} />
                <p style={{ color: '#7eaef5' }}>{translate('myPage')}</p>
              </>
            ) : (
              <>
                <FaceIcon className={FooterModule[iconClassName]} />
                <p>{translate('myPage')}</p>
              </>
            )}
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Footer
